import React, { useEffect, useState } from "react";
import { convertToHex, validateColor } from "./helpers";
import { tt } from "../../utils/i18n/i18n";
import "./styles.scss";
interface ColorInputProps {
  initialValue: string;
  onChange: (hexValue: string) => void;
}

const ColorInput: React.FC<ColorInputProps> = (props) => {
  const [colorValue, setColorValue] = useState<string>(props.initialValue);
  const [isValid, setIsValid] = useState<boolean>(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setColorValue(e.target.value);
  };

  useEffect(() => {
    if (!colorValue) {
      setIsValid(false);
      props.onChange("");
      return;
    }

    const valid = validateColor(colorValue);
    setIsValid(valid);

    if (!valid) {
      props.onChange("");
      return;
    }
    try {
      /**
       * The hex value return here is in lowercase
       */
      const hex = convertToHex(colorValue);
      if (hex !== props.initialValue.toLowerCase()) {
        props.onChange(hex);
      }
    } catch (e) {
      console.error("Error converting color:", e);
    }
  }, [colorValue]);

  useEffect(() => {
    setColorValue(props.initialValue);
  }, [props.initialValue]);

  return (
    <div className="color-input-container">
      <div className="input-group">
        <input
          type="text"
          value={colorValue}
          onChange={handleInputChange}
          placeholder={tt("colorInputPlaceholder")}
          className={`color-input ${isValid ? "valid" : colorValue ? "invalid" : ""}`}
        />
      </div>

      {colorValue && !isValid && (
        <div className="error-message">{tt("colorFormatError")}</div>
      )}

      {/*{isValid && (*/}
      {/*  <div className="color-info">*/}
      {/*    <p>Original: {colorValue}</p>*/}
      {/*    <p>Hex: {hexValue}</p>*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  );
};

export default ColorInput;
